var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedPDF)?_c('vue-pdf-app',{ref:"vue-pdf",attrs:{"theme":"dark","config":_vm.config,"pdf":_vm.selectedPDF},on:{"open":_vm.openHandler}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }